export const POPUP_CLASSNAME = "app-modal";
export const IS_QUBICTRON_DOMAIN = /(^|\.)qubictron\.(com|dev)$/i.test(window.location.hostname);
export const IS_QUBICTRON_AI_DOMAIN = /^www\.qubictron\.ai$/i.test(window.location.hostname);
export const APP_CONTAINER_CLASSNAME = "app-container";
export const APP_ROOT_CLASSNAME = "app-root";
export const DEFAULT_LANG = "en";
export const IS_APP_IN_IFRAME = window.self !== window.top;
export const MAX_PACKING_GROUPS = 50;
